// extracted by mini-css-extract-plugin
module.exports = {"services":"Services_services__L1ZbZ","title":"Services_title__m6mXB"};